export default __webpack_public_path__ + "static/media/motorDetailsIcon.e902ea7a.svg";